import { APPLICATION_PATHS, SECTIONS_PATHS } from '@framework/constants/enums';
import handlers from '@framework/guards/handlers';
import {
    adminPortalRouteGuard,
    attendeeViewRouteGuard,
    roomCreationRouteGuard,
    topicHubDetailsRouteGuard
} from '@framework/guards/oldRouteGuards';
import { type Handler } from '@framework/server/middleware';

const routeGuard: Handler<[], void> = async (ctx, contextMethods) => {
    const { axiosServer, call, dropLastVisited } = contextMethods;

    const splitUrl = ctx.asPath.split('/');
    const requestedPageRootPath = splitUrl[1] as APPLICATION_PATHS;
    const requestedPageSection = (
        requestedPageRootPath === APPLICATION_PATHS.ROOMS ? splitUrl[3] : splitUrl[4]
    ) as SECTIONS_PATHS;

    if (
        requestedPageSection === SECTIONS_PATHS.SIGNATURE_REQUEST ||
        requestedPageRootPath === APPLICATION_PATHS.LINK
    ) {
        return;
    }

    if (requestedPageSection === SECTIONS_PATHS.TOPIC_HUB && ctx.query.itemId) {
        await topicHubDetailsRouteGuard(ctx, axiosServer);
        return;
    }

    if (requestedPageRootPath === APPLICATION_PATHS.ORGANISATIONS) {
        await adminPortalRouteGuard(ctx, axiosServer);
        return;
    }

    if (requestedPageRootPath === APPLICATION_PATHS.ROOMS) {
        await attendeeViewRouteGuard(ctx, axiosServer);
        return;
    }

    if (
        requestedPageRootPath === APPLICATION_PATHS.ROOM_CREATION ||
        requestedPageRootPath === APPLICATION_PATHS.ROOM_EDIT
    ) {
        await roomCreationRouteGuard(ctx, axiosServer);
        return;
    }

    const routeHandler = handlers.find((handler) =>
        handler.test(ctx.asPath.endsWith('/') ? ctx.asPath : `${ctx.asPath}/`)
    );

    if (routeHandler) {
        await call(routeHandler.handler);
        return;
    }

    dropLastVisited();
};

export default routeGuard;
